import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useHistory } from "react-router";
import {
  Row,
  Col,
  Button,
  notification,
  Form,
  Input,
  Card,
  Divider,
} from "antd";
import { useTripsCtx } from "../../../context/TripDetailsContext";
import styles from "./ServiceSummaryComponent.module.scss";
import tripCardStyles from "../../Shared/Cards/TripCards/TripCards.module.scss";
import ServiceDateIcon from "../../../assets/images/ServiceDateIcon.svg";
import moment from "moment";
import {
  Mode,
  RegistrationEnums,
  TrackAnalytics,
  TripReasonEnum,
} from "../../../types/ApplicationTypes";
import grandTotalStyle from "../../DashBoard/BookingSummary/BookingSummary.module.scss";
import {
  leftOutlinedIcon,
  cancelSummery,
  clearIcon,
  backArrowIcon,
} from "../../../assets/images";
import {
  createReservation,
  getAliasesByCareReceiverId,
} from "../../../services/TripService";
import { CostDetails, TripType, TTrip } from "../../../types/TripTypes";
import { useMutation } from "@tanstack/react-query";
import GoogleLoader from "../../../assets/Loader/GoogleSvgLoader/GoogleLoader";
import html2canvas from "html2canvas";
import { usePaymentDetailsCtx } from "../../../context/PaymentDetailsContext";
import EmailTripBooking from "../../../helpers/EmailTripBooking";
import {
  TriggerEventId,
  EmailTripBookingModel,
} from "../../../types/EmailNotificationType";
import { usePlanDetailsCtx } from "../../../context/PlanDetailsContext";
import { useCreditCardActions } from "../../../hooks/useCreditCardActions";
import CreditCardErrorModal from "../../Shared/Modals/CreditCardErrorModal";
import { usePersonSummaryCtx } from "../../../context/PersonSummaryContext";
import DifferentCard from "../../Transportation/DifferentCard/DifferentCard";
import {
  TransportationModeV2,
  UpsertCreateReservationRequest,
  UpsertReservationRequest,
  UpsertReservationResponse,
} from "../../../types/TripTypesV2";
import { ITripCardDetails } from "../../ServiceUsers/Interfaces/ITripDetails";
import { useWindowSize } from "../../../hooks/useWindowSize";
import ServiceSummeryTripCostCard from "../ServiceSummeryTripCostCard/ServiceSummeryTripCostCard";
import ServiceSummeryTripDetails from "../ServiceSummeryTripDetails/ServiceSummeryTripDetails";
import TripLegCard from "../../Shared/Cards/TripCards/TripLegCard";
import CustomButton from "../../../common/Buttons/CustomButton";

interface IParams {
  serviceUserId: string;
  ride: string;
  levelOfService: string;
}

type Props = {
  updateTripDetails: Function;
};

const ServiceSummaryComponent: React.FC<Props> = ({ updateTripDetails }) => {
  const [isUseDifferentCard, setIsUseDifferentCard] = useState<boolean>(false);
  const [isEnterPromoCode, setIsEnterPromoCode] = useState<boolean>(false);
  const [isErrorCCModalVisible, setIsErrorCCModalVisible] = useState<boolean>(
    false
  );
  const [inputValidPromoCode, setInputValidPromoCode] = useState<string>("");
  const [isCreateTripLoading, setIsCreateTripLoading] = useState<boolean>(
    false
  );
  const [promoCode, setPromoCode] = useState<string>("");
  const [isMapDataLoading, setIsMapDataLoading] = useState<boolean>(false);

  const { serviceUserId, ride, levelOfService } = useParams<IParams>();

  const [form] = Form.useForm();

  const checkOutReferance = useRef<string[]>([]);

  const {
    defaultSavedCreditCardDetails: defaultCreditCard,
  } = usePaymentDetailsCtx();

  const {
    resetFormAndSetDefaults,
    validateCreditCardByPaymentInstrumentId,
  } = useCreditCardActions(form);

  const history = useHistory();
  const { width } = useWindowSize();

  const {
    bookedTripPaymentInstrumentIdCtx,
    tripSetupDetailsCtx,
    modeSelectionBackBtnCtx,
    tripScheduleDateCtx,
    wheelChairCtx,
    tripValidationIdCtx,
    wandaTripInfoCtx,
    mapBase64Ctx,
    wandaOrgId,
    showOrderSummaryCtx,
    isApplyButtonClickCtx,
  } = useTripsCtx();

  const { caregiverSummaryInfo } = usePersonSummaryCtx();
  const [showOrderSummary, setShowOrderSummary] = showOrderSummaryCtx;
  const [tripCreationDetails] = tripSetupDetailsCtx;
  const [tripScheduleDate] = tripScheduleDateCtx;
  const [wheelChair] = wheelChairCtx;
  const [rulesValidationId] = tripValidationIdCtx;
  const [, setIsModeSelectionBackBtnClicked] = modeSelectionBackBtnCtx;
  const [wandaTripInfo] = wandaTripInfoCtx;
  const [, setMapBase64] = mapBase64Ctx;
  const [, setBookedTripPaymentInstrumentId] = bookedTripPaymentInstrumentIdCtx;
  const [isApplyButtonClick, setIsApplyButtonClick] = isApplyButtonClickCtx;
  const isNotValidPromoCode = tripCreationDetails[0]?.errorDetail !== null;
  const isInputError = tripCreationDetails[0]?.isValid === false;
  const tripLegs: ITripCardDetails[] = tripCreationDetails.map(
    (record: TTrip, i: number) => {
      return {
        serviceUser: record.firstName,
        requestPickTime: record.pickTime,
        appointmentTime: null,
        providerDistance: record.distanceInMiles,
        isWillCall: record.isWillCall,
        pickUpAddress1: record?.pickupAddressDefault?.address1,
        dropOffAddress1: record?.dropOffAddressDefault?.address1,
        pickUpCity: record?.pickupAddressDefault?.city,
        pickUpState: record?.pickupAddressDefault?.state,
        dropOffCity: record?.dropOffAddressDefault?.city,
        dropOffState: record?.dropOffAddressDefault?.state,
        pickupNotes: record?.pickupAddressDefault?.driverInstruction,
        dropNotes: record?.dropOffAddressDefault?.driverInstruction,
      };
    }
  );

  const wandaPlusDiscountTotalCost = () => {
    let totalCost = 0;

    if (tripCreationDetails && Array.isArray(tripCreationDetails)) {
      for (let i = 0; i < tripCreationDetails.length; i++) {
        totalCost +=
          tripCreationDetails[i]?.legCostDetails?.wandaPlusDiscountCost ?? 0;
      }
    }
    if (tripCreationDetails[0]?.isPlus) {
      return totalCost;
    } else {
      return 0;
    }
  };

  const wandaPromoCodeDiscountTotalCost = () => {
    let totalCost = 0;

    if (tripCreationDetails && Array.isArray(tripCreationDetails)) {
      for (let i = 0; i < tripCreationDetails.length; i++) {
        totalCost +=
          tripCreationDetails[i]?.legCostDetails?.discountAmount ?? 0;
      }
    }
    return totalCost;
  };
  const tripGrantTotal = tripCreationDetails[0]?.grantTotal ?? 0;
  const wandaDiscountTotal = wandaPlusDiscountTotalCost();
  const promoCodeDiscountTotal = wandaPromoCodeDiscountTotalCost();
  const tripTotalSum =
    tripGrantTotal + wandaDiscountTotal + promoCodeDiscountTotal;

  const handleBack = () => {
    if (isEnterPromoCode && isNotValidPromoCode) {
      updateTripDetails(false, null);
    }
    if (!isUseDifferentCard) {
      setIsModeSelectionBackBtnClicked(true);
      history.goBack();
    } else {
      setIsUseDifferentCard(false);
      resetFormAndSetDefaults();
    }
    setIsEnterPromoCode(false);
  };

  const { tripDetailsInfo } = usePlanDetailsCtx();

  const handleUseSaveCard = async (paymentInstrumentId: number) => {
    try {
      setIsCreateTripLoading(true);
      setBookedTripPaymentInstrumentId(paymentInstrumentId);
      if (!isUseDifferentCard) {
        if (width > 992) await getPageEntries();
        await getTripMapData();
        const isValidCreditCard = await validateCreditCardByPaymentInstrumentId(
          defaultCreditCard.paymentInstrumentId
        );
        if (!isValidCreditCard) {
          setIsErrorCCModalVisible(true);
          return;
        }
      }
      const personAttributesList = await getAliasesByCareReceiverId(
        Number(serviceUserId)
      );
      let customerId = personAttributesList.find(
        (a) =>
          a.keyTypeId === RegistrationEnums.CustomerKeyTypeId &&
          a.sourceSystemId === wandaTripInfo.wandaMarketSourceSystemId &&
          a.organizationId === wandaOrgId.clientPlanId
      )?.businessKey;
      createTrip(Number(customerId), paymentInstrumentId);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to Create Trip. Please try again later.",
      });
    } finally {
      setIsCreateTripLoading(false);
      setShowOrderSummary(true);
    }
  };

  const createTrip = (customerId: number, paymentInstrumentId: number) => {
    const rideRequestList: UpsertReservationRequest[] = [];

    let mobilityAids = getMobilityAids(
      wheelChair?.wheelChairTravel,
      wheelChair?.wheelChairPresent
    );
    let tripModes: TransportationModeV2 = {
      modeId: ride === "Standard" ? Mode.Cab : Mode.Paralift,
      canTransfer: wheelChair?.wcToVehicleTransfer,
      levelOfService: getLevelOfService(levelOfService),
      passengerType: getPassengerType(
        wheelChair?.wheelChairTravel,
        wheelChair?.wheelChairPresent
      ),
      mobilityAids: [mobilityAids],
      conditions: [mobilityAids],
    };

    tripCreationDetails.forEach((tripsValue: TTrip) => {
      let filter: UpsertReservationRequest = {
        scheduledTime: tripsValue.scheduleTime
          ? moment(tripScheduleDate).format("YYYY-MM-DD")
          : null,
        appointmentTime:
          tripsValue.tripSelectedTypeDefault === TripType.ArrivedBy &&
          !tripsValue.isWillCall
            ? `${moment(tripScheduleDate).format("YYYY-MM-DD")}T${moment(
                tripsValue.scheduleTime,
                "h:mm a"
              ).format("HH:mm:ss")}`
            : undefined,
        pickTime:
          tripsValue.tripSelectedTypeDefault === TripType.LeaveAt &&
          !tripsValue.isWillCall
            ? `${moment(tripScheduleDate).format("YYYY-MM-DD")}T${moment(
                tripsValue.scheduleTime,
                "h:mm a"
              ).format("HH:mm:ss")}`
            : undefined,
        isWillCall: tripsValue.isWillCall || false,
        drop: {
          address1: tripsValue.dropOffAddressDefault?.address1
            ? tripsValue.dropOffAddressDefault?.address1.trim()
            : "",
          address2: tripsValue.dropOffAddressDefault?.address2
            ? tripsValue.dropOffAddressDefault?.address2.trim()
            : "",
          city: tripsValue.dropOffAddressDefault?.city
            ? tripsValue.dropOffAddressDefault?.city.trim()
            : "",
          state: tripsValue.dropOffAddressDefault?.state
            ? tripsValue.dropOffAddressDefault?.state.trim()
            : "",
          zip: tripsValue.dropOffAddressDefault?.zip
            ? tripsValue.dropOffAddressDefault?.zip.trim()
            : "",
          county: tripsValue.dropOffAddressDefault?.county
            ? tripsValue.dropOffAddressDefault?.county.trim()
            : "",
          notes: tripsValue.dropOffAddressDefault?.driverInstruction
            ? tripsValue.dropOffAddressDefault?.driverInstruction
            : "",
        },
        pick: {
          address1: tripsValue.pickupAddressDefault?.address1
            ? tripsValue.pickupAddressDefault?.address1.trim()
            : "",
          address2: tripsValue.pickupAddressDefault?.address2
            ? tripsValue.pickupAddressDefault?.address2.trim()
            : "",
          city: tripsValue.pickupAddressDefault?.city
            ? tripsValue.pickupAddressDefault?.city.trim()
            : "",
          state: tripsValue.pickupAddressDefault?.state
            ? tripsValue.pickupAddressDefault?.state.trim()
            : "",
          zip: tripsValue.pickupAddressDefault?.zip
            ? tripsValue.pickupAddressDefault?.zip.trim()
            : "",
          county: tripsValue.pickupAddressDefault?.county
            ? tripsValue.pickupAddressDefault?.county.trim()
            : "",
          notes: tripsValue.pickupAddressDefault?.driverInstruction
            ? tripsValue.pickupAddressDefault?.driverInstruction
            : "",
        },
        tripMode: tripModes,
        additionalPassengerInfo: [],
        tripPurposeId: TripReasonEnum.Wanda,
      };
      rideRequestList.push(filter);
    });

    const tripRequest: UpsertCreateReservationRequest = {
      reservations: rideRequestList,
      protocolInfo: {
        modeId: ride === "Standard" ? Mode.Cab : Mode.Paralift,
        rulesValidationId: rulesValidationId,
      },
      personId: Number(serviceUserId),
      benefitGroupId: wandaOrgId.benefitGroupId,
      customerId: customerId,
      date: moment(tripScheduleDate).format("YYYY-MM-DD"),
    };
    const context = { tripRequest, paymentInstrumentId };
    tripCreation.mutate(context);
  };

  const getLevelOfService = (levelOfService: string) => {
    if (levelOfService === CostDetails.CurbCurb) {
      return {
        id: 1,
        name: "Curb to Curb",
      };
    } else if (levelOfService === CostDetails.DoorDoor) {
      return {
        id: 2,
        name: "Door to Door",
      };
    } else {
      return {
        id: 3,
        name: "Door through Door",
      };
    }
  };
  const getPassengerType = (isWheelChair: boolean, isFoldable: boolean) => {
    if (isWheelChair) {
      if (isFoldable) {
        return {
          id: 5,
          name: "Wheel Chair",
        };
      } else {
        return {
          id: 9,
          name: "Wheelchair-Electric",
        };
      }
    } else {
      return {
        id: 2,
        name: "Ambulatory",
      };
    }
  };
  const getMobilityAids = (isWheelChair: boolean, isFoldable: boolean) => {
    if (isWheelChair) {
      if (isFoldable) {
        return "Wheel Chair";
      } else {
        return "Wheelchair-Electric";
      }
    } else {
      return "Ambulatory";
    }
  };

  const tripCreation = useMutation(
    async (context: {
      tripRequest: UpsertCreateReservationRequest;
      paymentInstrumentId: number;
    }): Promise<UpsertReservationResponse[]> =>
      createReservation(context.tripRequest, Number(serviceUserId)),
    {
      onError: () => {
        notification.error({
          message: "Error",
          description: "Failed to Create Trip. Please try again later.",
        });
      },
      onSuccess: async (data: UpsertReservationResponse[], context) => {
        if (
          data &&
          data[0].reservationId > 0 &&
          data[0].requestAssignmentId > 0
        ) {
          await updateTripDetails(
            true,
            inputValidPromoCode,
            data[0].requestAssignmentId,
            context.paymentInstrumentId
          );

          TrackAnalytics(
            "/DashBoard/Transportation/TripSummary",
            "Trip is booked successfully",
            "Trip summary Page"
          );

          let emailData: EmailTripBookingModel = {
            eventId: TriggerEventId.BookingSummary,
            careGiverPersonId: caregiverSummaryInfo.personId,
            careGiverName: caregiverSummaryInfo.firstName,
            organizationId: wandaOrgId.privatePayId,
            bookingId: String(data[0].reservationId),
            requestAssignmentId: data[0].requestAssignmentId,
            serviceUserPersonId: Number(serviceUserId),
            tripDate: tripScheduleDate,
            sourceSystemId: wandaTripInfo.wandaMarketSourceSystemId,
          };
          EmailTripBooking(emailData, tripDetailsInfo.wandaCustomerCareNumber);

          const bookingDate = moment(tripScheduleDate).format("MM/DD/YYYY");
          const endDate = moment(bookingDate)
            .clone()
            .add(1, "days")
            .format("MM/DD/YYYY");
          history.push(
            `/DashBoard/Transportation/BookingSummary/${data[0].reservationId}?scheduleDate=${bookingDate}&endDate=${endDate}`
          );
        } else {
          notification.error({
            message: "Error",
            description: "Failed to Create Trip. Please try again later.",
          });
        }
      },
    }
  );

  const handleEditTripSummary = () => {
    setIsModeSelectionBackBtnClicked(true);
    history.push(
      `/DashBoard/ScheduleService/TripSchedule/${caregiverSummaryInfo.personId}/${serviceUserId}?date=${tripScheduleDate}`
    );
  };
  useEffect(() => {
    if (!showOrderSummary) {
      setShowOrderSummary(width >= 992);
    }
  }, [width]);

  window.addEventListener("load", (event) => {
    history.push(`/DashBoard`);
  });

  const getPageEntries = async () => {
    const mapData: string[] = [];
    for (const [i, item] of tripCreationDetails.entries()) {
      const mapDiv = `map-${i + 1}`;
      let targetElement: HTMLElement | null = null;

      targetElement = document.getElementById(mapDiv);
      if (targetElement) {
        const canvas = await html2canvas(targetElement, { useCORS: true });
        const base64Data = await canvas.toDataURL("image/png");
        mapData.push(base64Data);
      }
    }
    checkOutReferance.current = mapData;
  };

  const getTripMapData = async (clickFrom?: string) => {
    try {
      clickFrom === "CheckoutAndUseDifferentCard" && setIsMapDataLoading(true);

      if (checkOutReferance.current?.length > 0) {
        setMapBase64(checkOutReferance.current);
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to Get Trip Map Data.",
      });
    } finally {
      setIsMapDataLoading(false);
    }
  };

  const toggleOrderSummary = async () => {
    await getPageEntries();
    setShowOrderSummary(!showOrderSummary);
  };

  const handleCheckoutAndUseDifferentCard = async () => {
    !isErrorCCModalVisible &&
      (await getTripMapData("CheckoutAndUseDifferentCard"));
    setIsErrorCCModalVisible(false);
    setIsUseDifferentCard(true);
  };

  const handleApplyPromoCode = async () => {
    setIsApplyButtonClick(true);
    setIsEnterPromoCode(true);
    try {
      await updateTripDetails(false, inputValidPromoCode);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Invalid promo code.",
      });
    } finally {
      setIsApplyButtonClick(false);
      setPromoCode("");
    }
  };

  const handleRemovePromoCode = () => {
    updateTripDetails(false, null);
    setPromoCode("");
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9$#@&]/g, "");
    if (isNotValidPromoCode) {
      setInputValidPromoCode(value);
    } else {
      setPromoCode(value);
    }

    if (value !== "" && !isNotValidPromoCode) {
      setInputValidPromoCode(value);
    }
    if (value === "" && isNotValidPromoCode) {
      handleRemovePromoCode();
    }
  };

  return (
    <>
      {tripCreation.isLoading ? (
        <GoogleLoader />
      ) : (
        <div className={styles.selectionContainer}>
          {width > 992 ? <div className={styles.line}></div> : null}

          {isUseDifferentCard ? (
            <>
              <Row align="middle">
                <Col xs={{ offset: 1 }} lg={{ offset: 4 }}>
                  <CustomButton
                    text="Back"
                    handlerFunction={handleBack}
                    type="link"
                    className="backBtn"
                    icon={backArrowIcon}
                  />
                </Col>
              </Row>
              <DifferentCard form={form} handleCreateTrip={handleUseSaveCard} />
            </>
          ) : (
            <>
              <Row
                className={`${
                  width < 992
                    ? `${styles.summeryHeading} ${styles.summeryHeadingContainer}`
                    : styles.summeryHeading
                }`}
              >
                {showOrderSummary ? (
                  <>
                    <Col
                      className={styles.leftOutlinedIconStyle}
                      onClick={handleBack}
                    >
                      <img src={leftOutlinedIcon} alt="leftOutlinedIcon" />
                    </Col>
                    <Col className={styles.summeryHeadingTextStyle}>
                      Service Summary
                    </Col>
                  </>
                ) : (
                  <>
                    <Row className={styles.orderSummaryContainer}>
                      <Col
                        className={`${styles.summeryHeadingTextStyle} ${styles.orderSummeryContainer}`}
                      >
                        Order Summary
                      </Col>
                      <Col
                        className={styles.closeIconStyle}
                        onClick={toggleOrderSummary}
                      >
                        <img src={cancelSummery} alt="leftOutlinedIcon" />
                      </Col>
                    </Row>
                    <div className={styles.line}></div>
                  </>
                )}

                {width < 992 && showOrderSummary ? (
                  <>
                    <Col
                      className={`${styles.checkoutButtonContainer} ${styles.mobileCheckoutButtonContainer}`}
                    >
                      <Button
                        className={styles.proceedCheckoutButton}
                        onClick={toggleOrderSummary}
                      >
                        Proceed to checkout
                      </Button>
                    </Col>

                    <div className={styles.line}></div>
                  </>
                ) : null}
              </Row>

              <Row className={styles.dashboardContainer}>
                <Col
                  xs={showOrderSummary ? 24 : 0}
                  sm={showOrderSummary ? 24 : 0}
                  md={showOrderSummary ? 24 : 0}
                  lg={16}
                >
                  <Col span={24} className={styles.commonMediumTextStyle}>
                    <Row className={styles.serviceDateContainer}>
                      <Col className={styles.commonMediumTextStyle}>
                        Planned trips
                      </Col>
                      <Col className={styles.servicedateIconContainer}>
                        <img
                          src={ServiceDateIcon}
                          className={styles.serviceDataIcon}
                          alt="ServiceDate-Icon"
                        />
                        <Col>
                          {tripScheduleDate &&
                            moment(tripScheduleDate).format("MM/DD/YYYY")}
                        </Col>
                      </Col>
                    </Row>
                  </Col>
                  {tripLegs.map((record: ITripCardDetails, i: number) => (
                    <React.Fragment key={`leg-${i + 1}`}>
                      <TripLegCard
                        leg={record}
                        legNumber={i + 1}
                        isMobileView={width < 992}
                      />
                      {tripLegs.length > i + 1 && (
                        <Divider
                          className={tripCardStyles.dashedDivider}
                          dashed
                        />
                      )}
                    </React.Fragment>
                  ))}
                </Col>

                <Col
                  xs={!showOrderSummary ? 24 : 0}
                  sm={!showOrderSummary ? 24 : 0}
                  md={!showOrderSummary ? 24 : 0}
                  lg={7}
                  offset={width < 992 ? 0 : 1}
                >
                  <Col
                    span={24}
                    className={`${
                      !showOrderSummary
                        ? styles.orderSummeryHide
                        : styles.commonMediumTextStyle
                    }`}
                  >
                    Order summary
                  </Col>
                  <div>
                    <ServiceSummeryTripCostCard
                      tripCreationDetails={tripCreationDetails}
                      handleUseSaveCard={handleUseSaveCard}
                      handleCheckoutAndUseDifferentCard={
                        handleCheckoutAndUseDifferentCard
                      }
                      isCreateTripLoading={isCreateTripLoading}
                    />
                  </div>

                  <Row
                    className={`${styles.costSeperationOrderDashed} ${styles.costSeperationOrderOuterWidth}`}
                  />

                  <Row
                    className={`${styles.promoCodeContainer} ${styles.costCardsContainer} `}
                  >
                    <Col span={24} className={styles.promoCodeHeading}>
                      Apply promo code
                    </Col>

                    <Row
                      className={`${styles.tripwidth} ${styles.commonSmallTextStyle}`}
                    >
                      <Col lg={17}>
                        <span
                          className={
                            isNotValidPromoCode && isInputError
                              ? ` ${styles.promoCodeInputContainer} ${styles.inputBoxErrorStyle}`
                              : styles.promoCodeInputContainer
                          }
                        >
                          <Input
                            value={
                              isNotValidPromoCode
                                ? inputValidPromoCode
                                : promoCode
                            }
                            placeholder="Enter code"
                            onChange={handleInputChange}
                          />

                          {isNotValidPromoCode && isInputError && (
                            <span className={styles.clearIconContainer}>
                              <img
                                className={styles.clearIconStyle}
                                src={clearIcon}
                                alt="clearIcon"
                                onClick={handleRemovePromoCode}
                              />
                            </span>
                          )}
                        </span>

                        {isNotValidPromoCode && (
                          <Row className={styles.errorMessage}>
                            {tripCreationDetails[0]?.errorDetail?.message}
                          </Row>
                        )}
                      </Col>

                      <Col lg={7}>
                        <Button
                          className={styles.promoCodeApplyButton}
                          onClick={handleApplyPromoCode}
                          disabled={
                            promoCode.length <= 0 || isNotValidPromoCode
                          }
                          loading={isApplyButtonClick}
                        >
                          Apply
                        </Button>
                      </Col>
                    </Row>
                  </Row>
                  {tripCreationDetails.map((record: TTrip, i: number) => {
                    return (
                      <ServiceSummeryTripDetails
                        tripCreationDetails={record}
                        tripNo={i + 1}
                      />
                    );
                  })}

                  <Row className={grandTotalStyle.grandTotalSection}>
                    <Col span={24} className={grandTotalStyle.normalText20}>
                      <Row gutter={[0, 16]}>
                        Total <Col span={24} />
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Row className={styles.costDetailsAlign} gutter={[0, 4]}>
                        <Col span={12} className={grandTotalStyle.boldText14}>
                          Trips ({tripCreationDetails.length})
                        </Col>
                        <Col span={12} className={grandTotalStyle.normalText14}>
                          ${tripTotalSum.toFixed(2)}
                        </Col>
                        <Col span={24} />
                      </Row>
                      <Row
                        className={`${grandTotalStyle.fadedNormalText14} ${styles.overallCostAlign}`}
                        gutter={[0, 4]}
                      >
                        {tripCreationDetails[0]?.isPlus && (
                          <>
                            <Col span={12}>Wanda Plus Discount</Col>
                            <Col
                              span={12}
                              className={grandTotalStyle.greenBoldText14}
                            >
                              {wandaTripInfo.wandaPlusDiscount * 100}%
                              {"\u00A0\u00A0"}-$
                              {wandaPlusDiscountTotalCost().toFixed(2)}
                            </Col>
                          </>
                        )}
                        {tripCreationDetails[0].legCostDetails?.discountType !==
                          null && (
                          <>
                            <Col span={12}>Promo Code</Col>
                            <Col
                              span={12}
                              className={grandTotalStyle.greenBoldText14}
                            >
                              {tripCreationDetails[0]?.legCostDetails
                                ?.discountType === "Percentage"
                                ? `${tripCreationDetails[0].legCostDetails?.discountValue}%`
                                : null}
                              {"\u00A0\u00A0"}
                              -$
                              {wandaPromoCodeDiscountTotalCost().toFixed(2)}
                            </Col>
                            <Col span={24}>
                              {tripCreationDetails[0]?.promoCode}
                            </Col>
                          </>
                        )}
                        <Divider className={styles.solidFadedDivider} />
                      </Row>
                      <Row
                        className={`${grandTotalStyle.normalText16} ${styles.overallCostAlign}`}
                        gutter={[0, 4]}
                      >
                        <Col span={12}>Total cost</Col>
                        <Col span={12}>
                          ${tripCreationDetails[0]?.grantTotal?.toFixed(2)}
                        </Col>
                        <Col span={24} className={grandTotalStyle.normalText14}>
                          You'll only be charged after each individual trip is
                          complete.
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}
        </div>
      )}

      <CreditCardErrorModal
        visible={isErrorCCModalVisible}
        setVisibility={setIsErrorCCModalVisible}
        handleUseDifferentCard={handleCheckoutAndUseDifferentCard}
        last4Digits={defaultCreditCard?.last4}
      />
    </>
  );
};

export default ServiceSummaryComponent;
